export const testimonials = [
  {
    quote: 'The Sugargoo spreadsheet completely changed how I shop. I used to spend hours searching for reliable sellers — now I find exactly what I need in minutes. The QC photos give me total confidence before I buy.',
    name: 'Marcus J.',
    handle: '@marcusfinds',
    rating: 4.9,
  },
  {
    quote: 'As someone new to Sugargoo, this spreadsheet was a lifesaver. The curated links and verified sellers saved me from making expensive mistakes. Cannot recommend it enough for first-time buyers.',
    name: 'Sophie L.',
    handle: '@sophiesshoplog',
    rating: 4.8,
  },
  {
    quote: 'I have been using Sugargoo for two years and discovering this spreadsheet resource took my finds to another level. The organization, the regular updates, the trusted seller verification — it is all top-notch.',
    name: 'Alex T.',
    handle: '@alextracker',
    rating: 5.0,
  },
];